import { render, staticRenderFns } from "./UserDeepDetail.vue?vue&type=template&id=2660c188"
import script from "./UserDeepDetail.vue?vue&type=script&lang=js"
export * from "./UserDeepDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports